import { useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { useSessionQuery } from './MsalAccessProvider';

import loading from '../loading.gif';

const SignOut = () =>
{
    const { instance } = useMsal();
    useSessionQuery('/logout');

    useEffect(() => {
        instance.logoutRedirect().catch(e => {
            console.error(e);
        });
    });

    return(
        <div className="flex flex-col my-8">
            <div className="text-center pt-4 pb-2 italic">
                Signing out...
            </div>
            <div className="flex justify-center pt-4 pb-2">
            <img alt="Loading..." src={loading} className='w-12' />
            </div>
        </div>
    );
};

export default SignOut;